import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { InitializationStatus } from '../../types';
import { reduxInitializationFailed, reduxInitialized, translationsImportFailed, translationsPreparedForImport } from '../actions/initialization';
export default handleActions({
    [`${reduxInitialized}`]: (state)=>_object_spread_props(_object_spread({}, state), {
            isReduxInitialized: InitializationStatus.Success
        }),
    [`${reduxInitializationFailed}`]: (state)=>_object_spread_props(_object_spread({}, state), {
            isReduxInitialized: InitializationStatus.Failure
        }),
    [`${translationsPreparedForImport}`]: (state)=>_object_spread_props(_object_spread({}, state), {
            areTranslationsInitialized: InitializationStatus.Success
        }),
    [`${translationsImportFailed}`]: (state)=>_object_spread_props(_object_spread({}, state), {
            areTranslationsInitialized: InitializationStatus.Failure
        })
}, {
    isReduxInitialized: InitializationStatus.Initializing,
    areTranslationsInitialized: InitializationStatus.Initializing
});

//# sourceMappingURL=initialization.js.map